module.exports = "<p>\n  minimapa works!\n</p>\n"